module.exports = __webpack_public_path__ + "static/img/c55cf16a3a77215f7335e2b96bba924e.594f007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/c55cf16a3a77215f7335e2b96bba924e.jpg
// module id = A0MP
// module chunks = 1